import { render, staticRenderFns } from "./FeaturedFlights.vue?vue&type=template&id=81d5a700&"
import script from "./FeaturedFlights.vue?vue&type=script&lang=js&"
export * from "./FeaturedFlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports